import React from "react";

export default function PlatformLogo({platform, size=20}){
  const parts=(platform.platformName||"Command").split(" ");
  return platform.platformLogo
    ?<img src={platform.platformLogo} style={{height:size+8,objectFit:"contain"}} alt={platform.platformName}/>
    :<span style={{fontFamily:"'Outfit','Inter',sans-serif",fontSize:size,fontWeight:600,letterSpacing:"-.01em"}}>
        {parts[0]}<span className="p-logo-accent">{parts.length>1?" "+parts.slice(1).join(" "):""}</span>
      </span>;
}
